export default __webpack_public_path__ + "static/media/4.f0e89bb4.jpg";